import jsSHA from "jssha"

export const getPasswordHash = (password: string): string => {
    const shaObj = new jsSHA("SHA-256", "TEXT")
    shaObj.update(password)
    return shaObj.getHash("B64")
}
